let judgeJson = require('../data/judges.json');

document.addEventListener("DOMContentLoaded", function(event) { 
    generateJudgeData();
});

window.onload = () => {
    handlePageLoaded();
};

function handlePageLoaded(){
    document.getElementsByClassName("loading-screen")[0].style.display = "none";
    document.getElementById("section-meetthejudges").style.display = "block";
}

async function generateJudgeData() {

    let container = document.querySelector("#judge-cards");

    judgeJson.forEach(judge => {
      container.innerHTML += `
      <div class="d-flex flex-wrap justify-content-center" id="judge-cards" data-aos="fade-up" data-aos-duration="500" >
        <div class="card judge-card m-3" style="width: 16rem;">
          <div class="d-flex justify-content-center align-items-center">
            <img src="${judge.photo}" class="mt-3 judge-image" alt="Photo of Judge ${judge.name}">
          </div>
          <div class="card-body p-4 pb-2">
            <h5 class="card-title fw-bold text-center">${judge.name}</h5>
            <p class="card-text text-center m-0 judge-position-text lh-1">${judge.position}</p>
          </div>
          <footer class="d-flex justify-content-center pb-4"><span class="badge judge-badge rounded-pill">${judge.company}</span></footer>
        </div>
      </div>
      `
    })
}
